import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBIcon,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from "mdbreact";
import euroLogo from "./../../../assets/img/eulogo2.png";
// import Contact from "./Contact.css";
import "../../../assets/css/contact.css";


const ContactPage = (props) => {
  return (
    <div className="main-con">
      <section className="my-5 container">
        <figure>
          <img src={euroLogo} className="figure-img img-fluid z-depth-1"
          alt="" style={{width: '100%'}} />
        </figure>
      </section>
    </div>
  );
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionContacts.jsx